import { ShoesState } from 'src/types'
import { getUpperMaterial } from '../logic'
import { dummy, getBaseCell, getColorCell } from 'src/util/simulationsSpecification'

export const getAtomsShoesBaseCells = (state: ShoesState) => {
  const toeGuard = state.toeGuard
  const isToeGuard = toeGuard.value !== 'none'
  const toeGuardState = isToeGuard ? { label: toeGuard.label, value: toeGuard.value } : toeGuard
  return [
    getBaseCell('アッパー素材', state.upperMaterial),
    getBaseCell('ソール', state.outSole),
    getBaseCell('サイズ', state.size),
    getBaseCell('甲止めタイプ', state.vampStrapType),
    getBaseCell('ベロタイプ', state.tongue),
    getBaseCell('履き口パターン', state.openingPattern),
    getBaseCell('ラインカラータイプ', state.lineType),
    getBaseCell('P革加工の有無', toeGuardState),
    isToeGuard ? getBaseCell('P革加工の種類', state.toeGuardKind) : dummy
  ].filter((cell) => cell.value !== 'dummy')
}

export const getAtomsShoesColorsCells = (state: ShoesState) => {
  const { isMesh } = getUpperMaterial(state)
  const isLine2 = state.lineType.value === 'doubleLine'
  const isMiddleCut = ['mountainMiddleCut', 'horizontalMiddleCut'].includes(state.openingPattern.value)
  const isMagicBelt = ['beltTypeSameDirection', 'beltTypeReverseDirection'].includes(state.vampStrapType.value)
  const isToeGuard = !['none', 'unselected'].includes(state.toeGuard.value)
  return [
    getColorCell(isMesh ? '本体メッシュ' : '本体カラー', state.mainUnit, 'mainUnit'),
    getColorCell(isMesh ? 'ベロ表メッシュ' : 'ベロ表', state.tongueFront, 'tongueFront'),
    getColorCell('つま先補強', state.toeReinforcement, 'toeReinforcement'),
    getColorCell('甲止め補強', state.vampStrapReinforcement, 'vampStrapReinforcement'),
    getColorCell('かかと補強', state.healReinforcement, 'healReinforcement'),
    getColorCell('サイド補強', state.sideReinforcement, 'sideReinforcement'),
    getColorCell('履き口補強', state.openingReinforcement, 'openingReinforcement'),
    getColorCell('かかと飾り', state.healDecoration, 'healDecoration'),
    getColorCell('ライン', state.line, 'line'),
    isLine2 ? getColorCell('ライン2', state.line2, 'line2') : dummy,
    isMagicBelt ? dummy : getColorCell(`紐`, state.vampStrap, 'vampStrap'),
    isMagicBelt ? getColorCell(`ベルト1${`(${state.magicBeltMaterial.label})`}`, state.vampStrapBelt1, 'vampStrapBelt1') : dummy,
    isMagicBelt ? getColorCell(`ベルト2${`(${state.magicBeltMaterial.label})`}`, state.vampStrapBelt2, 'vampStrapBelt2') : dummy,
    isMagicBelt ? getColorCell(`ベルト3${`(${state.magicBeltMaterial.label})`}`, state.vampStrapBelt3, 'vampStrapBelt3') : dummy,
    isMagicBelt ? getColorCell('ベルト裏地', state.magicBeltBase, 'magicBeltBase') : dummy,
    getColorCell('ステッチ', state.stitch, 'stitch'),
    getColorCell('ベロ裏', state.tongueLinings, 'tongueLinings'),
    isMiddleCut ? getColorCell('ミドルカット', state.middleCutOpening, 'middleCutOpening') : dummy,
    isToeGuard ? getColorCell('P革', state.toeGuardColor, 'toeGuardColor') : dummy,
    getColorCell('ラベル', state.atomsLabel, 'atomsLabel')
  ].filter((cell) => cell.head !== 'dummy')
}
